const resultsPanel = () => document.getElementById('newscred-results');
const resultReal = () => document.getElementById('result-real');
const resultFake = () => document.getElementById('result-fake');
const resultUnknown = () => document.getElementById('result-unknown');
const pressCouncil = () => document.getElementById('press-council');
const urlInput = () => document.getElementById('url');

function showElement(element) {
    if (element) {
        element.style.display = '';
    }
}

function hideElement(element) {
    if (element) {
        element.style.display = 'none';
    }
}

function clearFormErrors(form) {
    form.querySelectorAll('.form-error').forEach((errorElement) => {
        errorElement.remove();
    });
}

function clearResults() {
    hideElement(resultsPanel());
}

function clearSearchInput() {
    const input = urlInput();

    if (input) {
        input.value = '';
    }
}

function hideAllResults() {
    hideElement(resultReal());
    hideElement(resultFake());
    hideElement(resultUnknown());
    hideElement(pressCouncil());
}

function setAuthenticResult() {
    showElement(resultsPanel());
    hideAllResults();
    showElement(resultReal());
}

function setFakeResult() {
    showElement(resultsPanel());
    hideAllResults();
    showElement(resultFake());
}

function setUnknownResult() {
    showElement(resultsPanel());
    hideAllResults();
    showElement(resultUnknown());
}

function handleUrlQueryResponse(response) {
    if (!response || !response.data || !response.data.status) {
        setUnknownResult();

        return;
    }

    switch (response.data.status) {
        case 'Authentic':
            setAuthenticResult();
            break;
        case 'Fake':
            setFakeResult();
            break;
        case 'Unknown':
        default:
            setUnknownResult();
            break;
    }
}

function appendFieldError(form, fieldName, message) {
    const field = form.querySelector(`[name="${fieldName}"]`);

    if (!field) {
        return;
    }

    const errorElement = document.createElement('i');
    errorElement.className = 'form-error';
    errorElement.style.color = '#ed5454';
    errorElement.textContent = `*${message}`;
    field.after(errorElement);
}

function handleUrlQueryError(form, errorBody) {
    if (!errorBody || errorBody === 'NOT_FOUND') {
        setUnknownResult();

        return;
    }

    if (typeof errorBody === 'object' && errorBody !== null) {
        Object.entries(errorBody).forEach(([fieldName, message]) => {
            appendFieldError(form, fieldName, message);
        });

        return;
    }

    console.error(errorBody);
}

function collectFormValues(form) {
    const values = {};

    Array.from(form.elements).forEach((input) => {
        if (input.name && input.type !== 'submit') {
            values[input.name] = input.value;
        }
    });

    return values;
}

async function parseResponseBody(response) {
    const contentType = response.headers.get('content-type') ?? '';

    if (contentType.includes('application/json')) {
        return response.json();
    }

    return response.text();
}

async function submitUrlCheckerForm(form) {
    clearResults();
    clearFormErrors(form);

    const values = collectFormValues(form);

    try {
        const response = await fetch(form.action, {
            method: form.method || 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(values),
        });

        const body = await parseResponseBody(response);

        if (!response.ok) {
            handleUrlQueryError(form, body);

            return;
        }

        handleUrlQueryResponse(body);
    } catch (error) {
        setUnknownResult();
    }
}

function initNewscredForm() {
    const form = document.getElementById('url-checker-form');
    const clearButton = document.getElementById('clear-results');

    if (!form) {
        return;
    }

    clearResults();

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitUrlCheckerForm(form);
    });

    if (clearButton) {
        clearButton.addEventListener('click', () => {
            clearResults();
            clearSearchInput();
        });
    }
}

function bootNewscredForm() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initNewscredForm);
    } else {
        initNewscredForm();
    }
}

bootNewscredForm();
